import { gql } from '@apollo/client';

/**
 * 账单发送：预览（Step1）
 */
export const PREVIEW_BILL_SEND = gql`
  query PreviewBillSend($billId: ID!) {
    previewBillSend(billId: $billId) {
      canSend
      blockReasonCode
      blockReasonMessage
      billId
      clientName
      billPeriodText
      billAmountText
      financeContacts {
        name
        email
      }
      emails
      latestSendRecords {
        id
        senderEmail
        receiverEmail
        sendStatus
        errorMessage
        sentAt
        attachmentUrl
        operatorName
      }
    }
  }
`;

/**
 * 账单发送历史（分页）
 */
export const GET_BILL_SEND_HISTORY = gql`
  query GetBillSendHistory($billId: ID!, $pageRequest: PageRequestTypeInput) {
    getBillSendHistory(billId: $billId, pageRequest: $pageRequest) {
      content {
        id
        senderEmail
        receiverEmail
        sendStatus
        errorMessage
        sentAt
        attachmentUrl
        operatorName
      }
      pageInfo {
        page
        size
        totalElements
        totalPages
        hasNext
        hasPrevious
      }
    }
  }
`;

